var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"symbology-histogram",attrs:{"title":"Arrastrar la esquina para cambiar el tamaño"}},[_c('apexchart',{attrs:{"width":"100%","height":"100%","type":"bar","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }